// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2xaHV","box":"WorkspacesBox_box__3DKum","node":"WorkspacesBox_node__AQmvd"};